/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2020-11-26 19:13:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-29 13:17:56
 * @FilePath: /unifyxp-v2-store-portal/src/types/server/params.ts
 */
export enum EnumSalesChannelMultiLanguage {
  multiLanguageInParams = 'salesChannelMultiLanguageRequired',
  multiLanguageForceUpdate = 'salesChannelMultiLanguageUpdate',
  multiLanguageUsePrimaryLanguage = 'multiLanguageUsePrimaryLanguage',
  siteStyleInParams = 'salesChannelSiteStyleRequired',
  siteStyleForceUpdate = 'salesChannelSiteStyleUpdate',
  siteStyleSizeInParams = 'siteStyleSizeInParams',
}
export interface IParam {
  isGuest?: boolean;
  handleErrorAsResolve?: boolean;
  customHandleError?: boolean;
  multipleRequests?: boolean;
  params?: { [propName: string]: any };
  headers?: { [propName: string]: any };
  requestSourceID?: string;
  data?: { [propName: string]: any };
  returnWholeData?: boolean;
  afterSuccessCb?;
  afterSuccessEvents?;
  [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]?: boolean;
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]?: boolean;
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]?: boolean;
  [EnumSalesChannelMultiLanguage.siteStyleInParams]?: boolean;
  [EnumSalesChannelMultiLanguage.siteStyleForceUpdate]?: boolean;
  [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]?: boolean;
  isGql?: boolean;
}
